<script setup lang="ts">
import BookingSuggestionList from "@/views/Chat/BookingSuggestionList.vue";

const props = defineProps<{
    initData?: {withdrawerId?: number | null, employeeIds?: number[]}
}>()
</script>

<template>
    <BookingSuggestionList
        :employee-ids="props.initData?.withdrawerId != null ? [props.initData?.withdrawerId] : props.initData?.employeeIds"
        :active="true"
    />
</template>
